interface Storage {
  v_accessToken_v1: string;
  v_merchantId_v1: string;
  v_companyName_v1: string;
  v_applications_v1: {
    applicationId: string;
    applicationName: string;
    hasVirtualAccountsEnabled: boolean;
    hasEUR: boolean;
    hasGBP: boolean;
    hasEURForDefaultVirtual: boolean;
    hasGBPForDefaultVirtual: boolean;
  }[];
  v_email_v1: string;
  v_adminEmail_v1: string;
  v_userId_v1: string;
  v_adminOnlyMerchantsViewMode_v1: "table" | "grid";
}

export const StorageUtility = {
  setItem<K extends keyof Storage>(key: K, value: Storage[K]): void {
    try {
      const jsonValue = JSON.stringify(value);
      localStorage.setItem(key, jsonValue);
    } catch (e) {
      console.error(e);
    }
  },

  getItem<K extends keyof Storage>(key: K): Storage[K] | null {
    try {
      const jsonValue = localStorage.getItem(key);
      const value = jsonValue != null ? JSON.parse(jsonValue) : null;
      return value;
    } catch (e) {
      console.error(e);
      return null;
    }
  },

  removeItem(key: keyof Storage): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error(e);
    }
  },

  removeItems(keys: (keyof Storage)[]): void {
    try {
      keys.forEach((key) => {
        localStorage.removeItem(key);
      });
    } catch (e) {
      console.error(e);
    }
  },

  removeAll(): void {
    try {
      localStorage.clear();
    } catch (e) {
      console.error(e);
    }
  },
};
